import { createStyles, makeStyles } from "@material-ui/core";
import {
    Avatar,
    baseColors,
    getUserFromStorage,
    MessageComposerStandardButton,
    PhoneLink,
    RelodeTheme,
    Text,
} from "@relode/core";
import * as React from "react";

import { JobManagerContact } from "../../shared/types";

const useClasses = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                margin: theme.spacing(2, 2, 2, 2),
            },
            contactContainer: {
                display: "flex",
                flexDirection: "row",
                flexGrow: 1,
            },
            buttonContainer: {
                display: "flex",
                justifyContent: "center",
            },
            contact: {
                marginBottom: theme.spacing(2),
                marginTop: theme.spacing(1),
            },
            avatar: {
                height: 56,
                width: 56,
                marginRight: theme.spacing(2),
            },
            jobManager: {
                color: baseColors.gray,
                fontSize: "14px",
            },
        }),
    { name: "QuestionSection" }
);

export interface QuestionsSectionProps {
    id: string;
    jobManagerProfile: JobManagerContact;
}

export const QuestionsSection = React.memo((props: QuestionsSectionProps) => {
    const { id, jobManagerProfile } = props;
    const classes = useClasses({});
    const authenticatedUser = getUserFromStorage();

    if (!jobManagerProfile || !authenticatedUser) return null;

    return (
        <>
            <div id={id} className={classes.root}>
                <div className={classes.contactContainer}>
                    <Avatar
                        src={jobManagerProfile.profileImageUrl}
                        alt={jobManagerProfile.fullName}
                        initials={jobManagerProfile.initials}
                        className={classes.avatar}
                    />
                    <div>
                        <Text dataCy="jobManagerName" variant="h5">
                            {jobManagerProfile.fullName}
                        </Text>
                        <Text className={classes.jobManager}>Job Manager</Text>
                    </div>
                </div>
                <div className={classes.contact}>
                    {jobManagerProfile.phoneNumber && (
                        <PhoneLink
                            phone={jobManagerProfile.phoneNumber}
                            variant="textAndIcon"
                        />
                    )}
                </div>
                <MessageComposerStandardButton
                    color="primary"
                    leadId={jobManagerProfile.userId}
                    leadName={authenticatedUser.displayName}
                    initialRecipients={[
                        {
                            userId: jobManagerProfile.userId,
                            displayName: jobManagerProfile.fullName,
                            roleName: jobManagerProfile.roleName,
                        },
                    ]}
                />
            </div>
        </>
    );
});
